import { StorageKey } from '../../../enum/StorageKey';
import { ApiConsumer } from '../../../service/api-consumer';
import { initAxios } from '../../../service/axios';
import { loadHealthMonitorTokens } from '../../auth';
import { setItemToSessionStorage } from '../../session-storage';
import { loadDeviceList } from './load-device-list';

export const authAndLoadDevicesOnHealthMonitor = async () => {
  const hasLoadedTokens = loadHealthMonitorTokens();

  if (!hasLoadedTokens) {
    const tempToken = sessionStorage.getItem(StorageKey.ACCESS_TOKEN)?.trim();
    if (!tempToken) {
      throw new Error('Access token missing in sessionStorage');
    }

    const response = await ApiConsumer.authenticateOnHealthMonitor(tempToken);

    const accessToken = response?.accessToken?.trim();
    const refreshToken = response?.refreshToken?.trim();

    if (!accessToken || !refreshToken) {
      throw new Error('Authentication failed: missing access or refresh token.');
    }

    setItemToSessionStorage(StorageKey.ACCESS_TOKEN_HM, accessToken);
    setItemToSessionStorage(StorageKey.REFRESH_TOKEN_HM, refreshToken);

    initAxios(accessToken, refreshToken);
  }

  return await loadDeviceList();
};
